import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import { QRCodeCanvas } from "qrcode.react";

const BASE_URL = "https://www.mydatapulse.co.uk/arkana-rama/arun";

const user_details = {
  full_name: "Arun Kumar",
  name_hex:"#339999",
  qr_hex:"#DD6B2C",
  background_hex:"#282828",
  button_hex:"#DD6B2C",
  qr_code_for_hex:"#339999",
  company_logo:"https://www.mydatapulse.co.uk/assets/images/arkana-rama-logo-3.png"
}

function toTitleCase(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function QrGenerator() {

  const [firstName, setFirstName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const headerRef = useRef(null);

  const formattedName = toTitleCase(firstName.trim());
  const qrUrl = submitted
    ? `${BASE_URL}?first_name=${encodeURIComponent(formattedName)}`
    : BASE_URL;

  const handleSubmit = (e) => {
  e.preventDefault();
  if (formattedName) {
    setSubmitted(true);
    setTimeout(() => {
      headerRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100); // slight delay ensures QR is rendered
  }
};

  const resetForm = () => {
    setSubmitted(false);
    setFirstName("");
  };

  return (
    <>
      <Helmet>
        <title>Digital Connect | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div
        style={{
          height: '150vh',
          width: '100vw',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: user_details.background_hex

        }}
        >

      <div className="h-screen w-screen overflow-hidden flex flex-col">

        <section id="network-qr-generator" className="flex-1flex items-center justify-center">
          <div className="max-w-screen-xl px-4 pt-10 text-center flex flex-col items-center">
            {/* My Name */}
            <h2 style={{ color:user_details.name_hex }} className="text-5xl font-extrabold tracking-tight barlow-600">
              {user_details.full_name}
            </h2>

            {/* QR Code */}
            <div className="py-10">
              <QRCodeCanvas value={qrUrl} size={225} fgColor={user_details.qr_hex} bgColor={user_details.background_hex} />
            </div>

            {/* Reset Logo */}
            <button onClick={resetForm} className="mt-6" style={{ border: "none", background: "none" }}>
              <img
                className="px-5 lg:max-w-sm mx-auto cursor-pointer"
                src={user_details.company_logo}
                alt="logo image"
              />
            </button>

            {/* Form Input */}
            {!submitted && (
              <form onSubmit={handleSubmit} className="mt-10 flex flex-col items-center">
                <input
                  type="text"
                  placeholder="Enter first name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="border border-gray-300 px-4 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
                <button
                  type="submit"
                  style={{backgroundColor: user_details.button_hex}}
                  className="mt-4 px-5 py-2 rounded-lg transition"
                >
                  Generate QR
                </button>
              </form>
            )}

            {/* Optional subheading */}
            {submitted && (
              <p style={{color:user_details.qr_code_for_hex}} className="text-lg mt-10">
                QR Code for: <strong>{formattedName}</strong>
              </p>
            )}

          </div>
        </section>
      </div>
      </div>
    </>
  );
}

export default QrGenerator;
